import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
  },

  card: {
    width: "30%",
    height: "90%",
    minWidth: 360,
    marginTop: 70,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },

  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    color: "#077A97",
    marginTop: 12,
    marginBottom: 12,
    textTransform: "uppercase",
  },

  subtitle: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: "5%",
    borderBottomWidth: 0.2,
    borderBottomColor: "#077A97",
    paddingBottom: 2,
    paddingVertical: 2,
  },

  contentCard: {
    justifyContent: "space-between",
    paddingHorizontal: "5%",
    marginTop: 65,
  },

  descriptionElements: {
    paddingBottom: 2,
    paddingVertical: 2,
    flexDirection: "row",
    borderBottomWidth: 0.2,
    borderBottomColor: "#077A97",
    marginBottom: 14,
  },

  textDescription: {
    flex: 0.5,
    fontWeight: "400",
    fontSize: 14,
    color: "#000",
    textAlign: "left",
    alignItems: "left",
    textTransform: "uppercase",
  },

  textValue: {
    flex: 0.5,
    fontWeight: "400",
    fontSize: 14,
    color: "#656565",
    textAlign: "right",
    textTransform: "uppercase",
  },

  containerCompra: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: "5%",
  },

  lbl: {
    textTransform: "capitalize",
    fontWeight: "500",
    fontSize: 12,
  },

  btn: {
    backgroundColor: "#077A97",
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    marginBottom: 20,
    alignSelf: "center",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },

  containerErro: {
    alignItems: "center",
  },

  erroMinimo: {
    color: "red",
    paddingTop: 5,
    paddingBottom: 5,
  },

  btnVoltarText: {
    fontSize: 18,
    color: "#077A97",
    textTransform: "uppercase",
  },

  btnVoltar: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: "#077A97",
    backgroundColor: "#FFF",
    marginBottom: 20,
    alignSelf: "center",
  },
});

export default styles;
